import { HivSectionOne } from '@/components/hiv/HivSectionOne'
import { HivSectionTwo } from '@/components/hiv/HivSectionTwo'
import { HivSectionThree } from '@/components/hiv/HivSectionThree'
import { AboutUs } from '@/components/AboutUs'
import { ContactUs } from '@/components/ContactUs'

export const HivRouteComponent = () => {
	return (
		<>
			<HivSectionOne />
			<HivSectionTwo />
			<HivSectionThree />
			<AboutUs
				title={'About Wellview Care'}
				body={
					'Dedicated to our mission to eliminate STDs in high-risk communities and overall, our Wellview Care team puts leading treatments within' +
					' reach for the community members we serve. We are a 501(c)(3) nonprofit organization backed by ARNPs with extensive clinical practice' +
					' at the master’s degree level. Let’s elevate your immune health while making HIV undetectable.'
				}
				subTitle={'HIV Treatment Goals:'}
				items={[
					'Performing streamlined rapid HIV tests and labs, including creatinine tests',
					'Making PrEP and PEP available as necessary for prevention',
					'Assessing if BIKTARVY® is right for you as our preferred treatment method',
					'Building an end-to-end, tailored HIV treatment plan',
					'Carrying out anonymous notifications to your recent contacts',
					'Achieving and keeping HIV non-detectable in the blood',
					'And more',
				]}
			/>
			<ContactUs
				heading={'REACH OUT'}
				title={'Begin Your HIV Treatment Today'}
				subtitle={'HIV doesn’t define you. Get in touch with our Wellview team by submitting this form or using the contact methods below.'}
			/>
		</>
	)
}
